import t from"./_getMapData.js";var a=t;var r=function(t){return a(this,t).get(t)};export{r as default};
//# sourceMappingURL=_mapCacheGet.js.map
